import { render, staticRenderFns } from "./ViewSemesterPDF.vue?vue&type=template&id=158e5548&scoped=true"
import script from "./ViewSemesterPDF.vue?vue&type=script&lang=js"
export * from "./ViewSemesterPDF.vue?vue&type=script&lang=js"
import style0 from "./ViewSemesterPDF.vue?vue&type=style&index=0&id=158e5548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158e5548",
  null
  
)

export default component.exports